import { AsYouType } from 'libphonenumber-js/mobile';

export default class MobileLibphonenumberMask {
    telephone(value, country) {
        const countryUppercase = country.toUpperCase();

        let asYouType = new AsYouType();
        asYouType.defaultCountry = countryUppercase;
        asYouType.reset();
        asYouType.input(value);

        let maskTemplate = asYouType.getTemplate();
        maskTemplate = maskTemplate.replaceAll('(', '');
        maskTemplate = maskTemplate.replaceAll(')', '');
        maskTemplate = maskTemplate.replaceAll('x', '9');

        return maskTemplate;
    }
}
